var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAdvantages4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2387,
    height: 75,
    viewBox: "0 0 2387 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2336.5 47.4609H1843L1780 2.46094H0.984131",
    stroke: "url(#paint0_linear_3052_1054)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354 48.9609C2354 52.8269 2357.13 55.9609 2361 55.9609C2364.87 55.9609 2368 52.8269 2368 48.9609C2368 45.0949 2364.87 41.9609 2361 41.9609C2357.13 41.9609 2354 45.0949 2354 48.9609Z",
    fill: "#D71C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2337 48.9609C2337 62.2157 2347.75 72.9609 2361 72.9609C2374.25 72.9609 2385 62.2157 2385 48.9609C2385 35.7061 2374.25 24.9609 2361 24.9609C2347.75 24.9609 2337 35.7061 2337 48.9609Z",
    stroke: "#71253C",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_1054",
    x1: 1525.5,
    y1: 24.9609,
    x2: 2185.51,
    y2: 24.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71253C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2387,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAdvantages4);
export default __webpack_public_path__ + "static/media/line-Advantages4.549a322b439dbce8540a8b18b26fd04c.svg";
export { ForwardRef as ReactComponent };